import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getWebhookHistoryFetchSuccess, getWebhookHistoryFetchFailure } from './reducer';
import { WebhookHistoryResType } from 'src/types/webhookHistory';

const getWebhookHistoryFetchRequest = async () => {
    const res = await api('get', 'api/secure/webhooks/history');
    return res.data;
};

function* getWebhookHistoryFetch() {
    try {
        const response: WebhookHistoryResType = yield call((): any => getWebhookHistoryFetchRequest());
        yield put(getWebhookHistoryFetchSuccess(response));
    } catch (error) {
        yield put(getWebhookHistoryFetchFailure({ error }));
    }
}

export function* getWebhookHistoryFetchWatch() {
    yield takeEvery('webhookHistory/getWebhookHistoryFetch', getWebhookHistoryFetch);
}
